import ManageEventStandings from "./ManageEventStandings";
export default ManageEventStandings;
